// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-right-sidebar-standin{width:100%;display:flex}@media(min-width: 768px){.c-right-sidebar-standin{flex:0 0 380px}}@media(min-width: 1024px){.c-right-sidebar-standin{flex:0 0 380px}}@media(min-width: 1200px){.c-right-sidebar-standin{width:380px;min-width:380px}}.c-right-sidebar-standin--backdrop{background:var(--background--highlight);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}", ""]);
// Exports
module.exports = exports;
